import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IUserTable, IUserTableRedux, ITarget } from '../../types/interfaces';

import UserEdit from './UserEdit';
import UserDelete from './UserDelete';
import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faUserCog, faPen, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';
import { SelectColumnFilter } from '../tables_manager/filters';
import { beautifyName } from '../../services/misc';

const UserTable = ({ 
  usersData,
  setTableData,
  societes
 }: IUserTable) => {
  const [selectedValue, setSelectedValue] = useState('');
  const skipResetRef = React.useRef(false);
  const [modal, setModal] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalUser, setModalUser] = useState('');
  const [modalDeleteUser, setModalDeleteUser] = useState('');
  const [copiedFlag, setCopiedFlag] = useState(false);
  const history = useHistory();

  const alert = useAlert();

  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/gestion_utilisateur/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/gestion_utilisateur/${id}` })
    }
    else
      alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
  }

  const handleCopy = (e) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    setCopiedFlag(true);
    setTimeout(() => setCopiedFlag(false), 2000);
  };
  
  const handleSelectChange = data => {
    setSelectedValue(data ? data.value : '');
  }
  
  const handleToggle = () => setModal(!modal);
  const handleToggleDelete = () => setModalDelete(!modalDelete);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => {
          return (<a href={value !== null && value !== undefined ? (`/gestion_utilisateur/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/gestion_utilisateur/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/gestion_utilisateur/${value}` })
            }
            else
              alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        }
      },
      {
        Header: "Nom Complet",
        accessor: "Nom Complet",
        filter: (rows, id, e) => rows.filter(t => (t.original.given_name || t.original.surname) && `${t.original.surname || ""} ${t.original.given_name || ""}`.toLowerCase().includes((e || "").toLowerCase())),
        sortType: (a, b, id, desc) => `${a.original.surname || ""} ${a.original.given_name || ""}` > `${b.original.surname || ""} ${b.original.given_name || ""}` ? 1 : -1,
        // Cell: ({ row: {original: o} }) => o.given_name || o.surname ? `${o.surname ? o.surname.charAt(0).toUpperCase() + o.surname.slice(1).toLowerCase() : ""} ${o.given_name ? o.given_name.charAt(0).toUpperCase() + o.given_name.slice(1).toLowerCase() : ""}` : "-"
        Cell: ({ row: {original} }) => beautifyName(original.given_name, original.surname)
      },
      {
        Header: "Nom de Compte",
        accessor: "username",
      },
      {
        Header: "Numéro(s) de Téléphone",
        accessor: "phone",
        disableSortBy: true,
        Cell: ({ row }) => row.original.phone ? <div style={{whiteSpace: "nowrap"}}>
          {row.original.phone.length >= 4 && row.original.phone[0] !== "0" ? ("+" + row.original.phone) : row.original.phone}
          <a data-tip data-for="telI" href={`tel:${(row.original.phone.length >= 4 && row.original.phone[0] !== "0" ? ("+" + row.original.phone) : row.original.phone).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
          <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
          <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.phone)} />
          <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
            <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
          </ReactTooltip>
        </div> : "-"
      },
      {
        Header: "Rôle",
        // accessor: "speciality",
        accessor: (row, index) => {
          let s = "";
          switch(row.speciality){
            case constants.ROLE_ADMIN: s = "Administrateur"; break;
            case constants.ROLE_COMMERCIAL: s = "Commercial"; break;
            case constants.ROLE_COMPTABLE: s = "Comptable"; break;
            case constants.ROLE_RESPONSABLE: s = "Responsable"; break;
            case constants.ROLE_PROMOTEUR: s = "Promoteur"; break;
            case constants.ROLE_INTERMEDIAIRE: s = "Intermédiaire"; break;
            case constants.ROLE_DG: s = "Directeur Général"; break;
            case constants.ROLE_DC: s = "Directeur Commercial"; break;
            case constants.ROLE_DAF: s = "Directeur Administratif et Financier"; break;
          }
          return s
        },
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ row: {original} }) => {
          let s = "-";
          switch(original.speciality){
            case constants.ROLE_ADMIN: s = "Administrateur"; break;
            case constants.ROLE_COMMERCIAL: s = "Commercial"; break;
            case constants.ROLE_COMPTABLE: s = "Comptable"; break;
            case constants.ROLE_RESPONSABLE: s = "Responsable"; break;
            case constants.ROLE_PROMOTEUR: s = "Promoteur"; break;
            case constants.ROLE_INTERMEDIAIRE: s = "Intermédiaire"; break;
            case constants.ROLE_DG: s = "Directeur Général"; break;
            case constants.ROLE_DC: s = "Directeur Commercial"; break;
            case constants.ROLE_DAF: s = "Directeur Administratif et Financier"; break;
          }
          return s
        }
      },
      {
        Header: "Travaille à",
        accessor: "worksatProjects",
        filter: (rows, id, e) => rows.filter(t => (t.original.worksatProjects?.filter((e, index, self) => self.findIndex(t => t.id === e.id) === index).map(e => e.LIBELE || "-") || []).filter(n => n?.toLowerCase().includes(e.toLowerCase())).length),
        customExportDisplay: `($.worksatProjects && $.worksatProjects.length) ? $.worksatProjects.filter((e, index, self) => self.findIndex(t => t.id === e.id) === index).map(t => t.LIBELE ? t.LIBELE : "-").join(" / ") : "-"`,
        Cell: ({ row: {original} }) => original.worksatProjects?.length ? original.worksatProjects.filter((e, index, self) => self.findIndex(t => t.id === e.id) === index).map(t => t.LIBELE || "-").join(", ") : "-"
      },
      {
        Header: "Bloqué",
        accessor: e => e.bloque == 1 ? "Oui" : "Non",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value }) => <div style={value === "Oui" ? {color: "red"} : {}}>{value}</div>
      },
      {
        Header: "Commentaire",
        accessor: "comment",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={(e) => viewCard(e, row.original.id)}
                  title="Ouvrir la fiche de l'utilisateur">
                  <FontAwesomeIcon icon={faUserCog} />
                </button>
                <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {setModalUser(row.original); setModal(true)}}
                  title="Modifier">
                  <FontAwesomeIcon icon={faPen} />
                </button>
                <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {setModalDeleteUser(row.original); setModalDelete(true)}}
                  disabled
                  title="Supprimer">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [usersData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={usersData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <UserEdit modal={modal} setModal={setModal} handleToggle={handleToggle} modalUser={modalUser} users={usersData} societes={societes} />
      <UserDelete modal={modalDelete} setModal={setModalDelete} handleToggle={handleToggleDelete} modalUser={modalDeleteUser} />
    </div>
  );
};

const mapStateToProps = (state: IUserTableRedux) => ({
});

export default connect(mapStateToProps, {})(UserTable);
